import { Period, UnixTime } from 'dashboard/lib/unixTime';
import { Iso8601DateString } from 'lib/types';

export interface ReportIdentifier {
  id: number;
  token: string;
  name: string;
  updated_at?: Iso8601DateString;
  type?: string;
}

export enum ReportRunTypes {
  First = 'first',
  Subsequent = 'subsequent',
}

export interface ReportsSummaryDatum {
  created_count: number;
  ready_count: number;
  matched_count: number;
  run_type: ReportRunTypes;
}

export interface ReportsMetricsSummary extends ReportIdentifier {
  data: Array<ReportsSummaryDatum>;
}

export interface ReportsOverTimeDatum {
  created_timestamp: UnixTime;
  ready_count: number;
  match_rate: number;
}

export interface ReportsSummaryOverTime {
  run_type: ReportRunTypes;
  data: Array<ReportsOverTimeDatum>;
}

export interface ReportsMetricsOverTime extends ReportIdentifier {
  data: Array<ReportsSummaryOverTime>;
}

export interface ReportsOverTimeResponse {
  data: Array<ReportsMetricsOverTime>;
  domain: [number, number];
  period: Period;
}

export interface ReportsChartDatum {
  created_timestamp: UnixTime;
  first_ready_count?: number;
  first_match_rate?: number;
  subsequent_ready_count?: number;
  subsequent_match_rate?: number;
}
